import { createAction, props } from '@ngrx/store'
import { AssignedPermissionSets } from './assigned-permissionsets.state'

// Action to load AssignedPermissionSets
export const loadAssignedPermissionSets = createAction(
  '[AssignedPermissionSets] Load AssignedPermissionSets',
  props<{ id: string; params?: string | null; page?: number; limit?: number }>()
)

// Action for successful AssignedPermissionSets load
export const loadAssignedPermissionSetsSuccess = createAction(
  '[AssignedPermissionSets] Load AssignedPermissionSets Success',
  props<{
    totalCount: number
    assignedPermissionSets: AssignedPermissionSets[]
  }>()
)

// Action for AssignedPermissionSets load failure
export const loadAssignedPermissionSetsFailure = createAction(
  '[AssignedPermissionSets] Load AssignedPermissionSets Failure',
  props<{ error: string }>()
)

export const loadAssignedPermissionSetsCounts = createAction('[AssignedPermissionSets] Load Counts')
export const setAssignedPermissionSetsCounts = createAction(
  '[AssignedPermissionSets] Set Counts',
  props<{ totalCount: number }>()
)

export const createAssignedPermissionSets = createAction(
  '[AssignedPermissionSets] Create AssignedPermissionSets',
  props<{
    validUpto?: string
    permissionSetIds: number[]
    userId: string
  }>()
)

export const createAssignedPermissionSetsSuccess = createAction(
  '[AssignedPermissionSets] Create AssignedPermissionSets Success',
  props<{ assignedPermissionSets: AssignedPermissionSets[] }>()
)

export const createAssignedPermissionSetsFailure = createAction(
  '[AssignedPermissionSets] Create AssignedPermissionSets Failure',
  props<{ error: any }>()
)

export const updateAssignedPermissionSets = createAction(
  '[AssignedPermissionSets] Update AssignedPermissionSets',
  props<{
    id: string
    validUpto: string
    userRoleId: number
    userId: string
  }>()
)

export const updateAssignedPermissionSetsSuccess = createAction(
  '[AssignedPermissionSets] Update AssignedPermissionSets Success',
  props<{ assignedPermissionSet: AssignedPermissionSets }>()
)

export const updateAssignedPermissionSetsFailure = createAction(
  '[AssignedPermissionSets] Update AssignedPermissionSets Failure',
  props<{ error: any }>()
)
